import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Container,
  Grid,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ReceiptLong from "@mui/icons-material/ReceiptLong";
import Category from "@mui/icons-material/Category";
import Person from "@mui/icons-material/Person";
import CalendarToday from "@mui/icons-material/CalendarToday";
import { CalendarMonth } from "@mui/icons-material";

// --- กลุ่มรายงานการซื้อ ---
const purchaseReports = [
  // {
  //   label: "สรุปยอดซื้อประจำวัน",
  //   icon: <CalendarToday fontSize="large" />,
  //   route: "/reports/daily_purchases",
  // },
  {
    label: "สรุปยอดซื้อสินค้ารายบุคคล",
    icon: <Person fontSize="large" />,
    route: "/reports/individual_purchases",
  },
  {
    label: "สรุปยอดซื้อสินค้ารายชนิด",
    icon: <Category fontSize="large" />,
    route: "/reports/summary_purchases_product",
  },
  {
    label: "สรุปยอดซื้อรายBatch",
    icon: <ReceiptLong fontSize="large" />,
    route: "/reports/summary_ticket_purchases",
  },
  {
    label: "สรุปยอดซื้อรายเดือน",
    icon: <CalendarMonth fontSize="large" />,
    route: "/reports/monthly_purchases",
  },
  {
    label: "สรุปยอดขายรายเดือน",
    icon: <CalendarMonth fontSize="large" />,
    route: "/reports/monthly_withdrawl",
  },
  // {
  //   label: "ต้นทุนสินค้าคงเหลือ",
  //   icon: <MonetizationOnIcon fontSize="large" />,
  //   route: "/reports/cost_inventory",
  // },
  // {
  //   label: "10 อันดับ ยอดซื้อรายบุคคลประจำเดือน",
  //   icon: <ReceiptLong fontSize="large" />,
  //   route: "/reports/top_monthly_purchases",
  // },
];

// --- กลุ่มรายงานการขาย ---
const salesReports = [
  {
    label: "สรุปยอดขายประจำวัน",
    icon: <CalendarToday fontSize="large" />,
    route: "/reports/daily_sales",
  },
  {
    label: "สรุปยอดขายสินค้ารายบุคคล",
    icon: <Person fontSize="large" />,
    route: "/reports/individual_sales",
  },
  {
    label: "สรุปยอดขายสินค้ารายชนิด",
    icon: <Category fontSize="large" />,
    route: "/reports/summary_sales_product",
  },
  {
    label: "สรุปยอดขายรายBatch",
    icon: <ReceiptLong fontSize="large" />,
    route: "/reports/summary_ticket_sales",
  },
  {
    label: "10 อันดับ ยอดขายรายบุคคลประจำเดือน",
    icon: <ReceiptLong fontSize="large" />,
    route: "/reports/top_monthly_sales",
  },
];

const HomePage = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (auth !== null) {
      setIsLoading(false);
    }
  }, [auth]);

  if (isLoading) {
    return (
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  const renderReportGroup = (title, reports) => (
    <Box sx={{ mt: 6 }}>
      <Typography
        variant="h6"
        sx={{ mb: 3, fontWeight: "bold", textAlign: "center" }}
      >
        {title}
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {reports.map((btn, index) => (
          <Grid item xs={12} sm={4} md={2} key={index}>
            <Box
              onClick={() =>
                btn.external
                  ? window.open(btn.route, "_blank")
                  : navigate(btn.route)
              }
              sx={{ cursor: "pointer", textAlign: "center" }}
            >
              <Paper
                elevation={6}
                sx={{
                  p: 3,
                  borderRadius: "50%",
                  backgroundColor: "#ffffff",
                  width: 120,
                  height: 120,
                  mx: "auto",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  transition: "all 0.3s",
                  ":hover": {
                    backgroundColor: "#185519",
                    color: "#fff",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <IconButton color="inherit" size="large">
                  {btn.icon}
                </IconButton>
              </Paper>
              <Typography align="center" sx={{ mt: 2, fontWeight: "bold" }}>
                {btn.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  return (
    <Box
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      sx={{
        background: "linear-gradient(135deg, #e0f7fa, #ffffff)",
        px: 2,
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        {renderReportGroup("รายงานการซื้อ", purchaseReports)}
        {/* {renderReportGroup("รายงานการขาย", salesReports)} */}
      </Container>
    </Box>
  );
};

export default HomePage;
